import React, { Component } from 'react';
// import { inject , observer} from 'mobx-react'
import { Modal } from 'antd';
import { store } from 'Store/store.index';
import { isMobile, isMacSsoNoIos } from 'Utils/device';
import { isQQ, isBaidu, isSafari } from 'Utils/browser-info';

export default class SubscriptionMember extends Component {
  constructor(props) {
    super(props);
    
  }
  onOk = () => {
    let payOrigin = (isMacSsoNoIos || isSafari) ? 'edit.foxitcloud.cn/pay/edit/' : 'www.foxitcloud.cn/pay/edit/';
    let url = ''
    if(isMobile) {
      url = `https://vip.foxitreader.cn/edit-h5/pay/${location.search}`
    } else {
      url = `https://${payOrigin}?${location.search.trim().slice(1)}`;
      if (window.location.search.includes("from=pdf365/?refer=bd")) {
        url = `https://www.foxitcloud.cn/pay/edit/baidu365/${location.search.trim().slice(1) && "?"}${location.search.trim().slice(1)}`;
      }
      // url = `https://${payOrigin}${location.search}`
    }
    store.common.getIsShowOpenMember(false)
    store.common.setIsShowMeeting(false)
    store.saveFileNewStore.setShowDialog(false)
    if(isMobile) {
      if(isQQ || isBaidu) {
        window.open(url, '_blank','width=100%')
      } else {
        window.open(url);
      }
    } else {
      window.open(url);
    }
  };
  onCancelShow = () => {
    store.common.getIsShowOpenMember(false)
    store.saveFileNewStore.setShowDialog(false)
    store.common.setIsShowMeeting(false)
  };


  render() {
    // const { showDialog } = store.saveFileNewStore
    const msg = this.props;
    return (
      <React.Fragment>
        <div>
          {
            !isMobile && <Modal
            visible={msg.visible}
            className='common-dialog ant-alert-modal subscriptionMember'
            title='福昕云编辑'
            onCancel={this.onCancelShow}
            okText = '订阅'
            cancelText = '取消'
            onOk={this.onOk}
            >
            <div className={`msg-dlg-content-wrapper ` + (msg.iconType === 'prompt' ? 'prompt' : '')}>
              <div className={`msg-wrapper ` + (msg.iconType === 'prompt' ? 'prompt-wrapper' : '')}>
                {msg.iconType === 'warning' && <i className="msg-icon warning"/>}
                {msg.iconType === 'alert' && <i className="msg-icon alert"/>}
                {msg.iconType === 'error' && <i className="msg-icon error"/>}
                {msg.iconType === 'inquiry' && <i className="msg-icon inquiry"/>}
                {msg.iconType === 'prompt' && <i className="msg-icon prompt"/>}
                <div>您还不是订阅用户，该功能为订阅用户专享功能，请订阅后使用</div>
              </div>
            </div>
          </Modal>
          }
          {
            isMobile && 
            <div className="fwMobileDialog" onClick={this.onCancelShow}>
              <div className="fwMobileDialogBox"  onClick={(e) =>{e.stopPropagation()}}>
                <div className="fwMobileDialogMain">
                  <img src={require("../../assets/fw_cloud_editor_mobile/img_warnning.png")}></img>
                  <p>您还不是订阅用户，该功能为订阅用户专享功能，请订阅后使用</p>
                </div>
                <div className="fwMobileDialogBoxFooter">
                  <span className="fwMobileDialogFooterCancel" onClick={this.onCancelShow}>取消</span>
                  <span className="fwMobileDialogFooterOK" onClick={() => {this.onOk()}}>订阅</span>
                  {/* <a className="fwMobileDialogFooterOK" target='_blank' rel="noopener noreferrer" href='https://vip.foxitreader.cn/edit-h5/pay/'>订阅</a> */}
                </div>
              </div>
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}